import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		borderRadius: "50%",
		width: "60px",
		height: "60px",
		border: `1px solid ${theme.palette.colors.oneMoreGrey}`,
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& span": {
			fontSize: "16px",
			color: theme.palette.colors.cloudyBlue,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			border: "none",
			borderRadius: 0,
			width: "20px",
			height: "20px",
		},
	},
});

class Close extends React.Component {
	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root} onClick={this.props.onClickHandler}>
				<span className={"icon24 icon-close"}></span>
			</div>
		);
	}
}

export default withStyles(styles)(Close);
